export const initializeFindStorePrompt = () => {
  const body = document.querySelector('body');
  body.classList.add('util-overflow-hidden');

  const findStoreButton = document.querySelector('#find-store-button');
  if (findStoreButton) {
    const findStoreEvent = new CustomEvent('find-store');
    findStoreButton.addEventListener('click', () => {
      document.dispatchEvent(findStoreEvent);
    });
  }
};
